import { Text } from '@wix/design-system';
import clsx from 'clsx';
import { useTranslation } from '@wix/fe-essentials-standalone';
import s from '../ProviderReviewSummary.module.scss';

const ReviewCount = ({
  isMobileView,
  reviewsCount,
}: {
  isMobileView: boolean;
  reviewsCount?: number;
}) => {
  const {
    i18n: { language },
  } = useTranslation();

  return (
    <Text
      size="tiny"
      weight="thin"
      className={clsx(s.subText, isMobileView && s.mobile)}
      skin="standard"
    >
      ({Intl.NumberFormat(language, {}).format(reviewsCount ?? 0)})
    </Text>
  );
};

export default ReviewCount;
